// 表头
const operationForm = [
    {
      prop: "realName",
      label: "考核时间",
      width: "260px",
    },
    {
      prop: "telephone",
      label: "考核状态",
    },
    {
      prop: "managerType",
      label: "考场状态",
    },
    {
      prop: "title",
      label: "已考人数",
    },
    {
      prop: "title",
      label: "未考人数",
    },
    {
      prop: "title",
      label: "创建时间",
    },
    {
      prop: "title",
      label: "创建人",
    },
  ];
  // 操作表头
  const operation = [
    {
      prop: "time",
      label: "考核时间",
      width: "260px",
    },
    {
      prop: "examStatus",
      label: "考核状态",
    },
    {
      prop: "Status1",
      label: "考场状态",
    },
    {
      prop: "ApplyUser",
      label: "已考人数",
    },
    {
      prop: "TotalUser1",
      label: "未考人数",
    },
    {
      prop: "CreateTime1",
      label: "创建时间",
      width: "160px",
    },
    {
      prop: "RealName",
      label: "创建人",
    },
  ];
  const operationTable = [
    {
      prop: "time",
      label: "考核时间",
      width: "260px",
    },
    {
      prop: "examStatus",
      label: "考核状态",
    },
    {
      prop: "TotalUser",
      label: "应考人数",
    },
    {
      prop: "ApplyUser",
      label: "已考人数",
    },
    {
      prop: "TotalUser1",
      label: "未考人数",
    },
    {
      prop: "PassUser",
      label: "及格人数",
    },
    {
      prop: "CreateTime1",
      label: "创建时间",
      width: "160px",
    },
    {
      prop: "RealName",
      label: "创建人",
    },
  ];
  
  // 卡片
  const cardList = [
    {
      title: "应考总人数",
      num: 100,
      type:'TotalUser'
    },
    {
      title: "总分",
      num: 100,
      type:'TotalScore'
    },
    {
      title: "及格分",
      num: 60,
      type:'PassScore'
    },
    {
      title: "及格人数",
      num: 94,
      type:'PassUser'
    },
    {
      title: "不及格人数",
      num: 6,
      type: "NoPasstUser",
    },
    {
      title: "缺考人数",
      num: 0,
      type: "NotUser",
    },
    {
      title: "最高分",
      num: 98,
      type: "MaxScore",
    },
    {
      title: "最低分",
      num: 50,
      type: "MinScore",
    },
  ];
  const monitoringlist = [
    {
      prop: "RealName",
      label: "考生名字",
    },
    {
      prop: "UserName",
      label: "考生账号",
    },
    {
      prop: "DepartmentName",
      label: "科室",
    },
    {
      prop: "PTitle",
      label: "职称",
    },
    {
      prop: "Score",
      label: "操作分数",
    },
    {
      prop: "ApplyTime1",
      label: "考核完成时间",
      width: "160px",
    },
    {
      prop: "IsScore1",
      label: "评分状态",
    },
    {
      prop: "Teacher",
      label: "监考员",
    },
    {
      prop: "IsPublish1",
      label: "发布状态",
    },
  ];
  const scoreTabel = [
    {
      prop: "Title",
      label: "评分表名称",
    },
    {
      prop: "TotalScore",
      label: "评分表总分",
    },
    {
      prop: "PassScore",
      label: "及格分数",
    },
    {
      prop: "CreateTime1",
      label: "创建时间",
      width: "160px",
    },
    {
      prop: "RealName",
      label: "创建人",
    },
  ];
  const modelArr = [
    {
      value: "0",
      label: "待考核",
    },
    {
      value: "1",
      label: "考核中",
    },
    {
      value: "2",
      label: "考核结束",
    },
  ];
  const objecAtrtIsEmpty = function (data) {
    // 如果是数组，遍历数组里面的
    if (Array.isArray(data)) {
      if (data.length == 0) return false;
      return data.every((el) => {
        return objecAtrtIsEmpty(el);
      });
      // 非空数组
    } else if (
      Object.prototype.toString.call(data) === "[object Object]" &&
      JSON.stringify(data) !== "{}"
    ) {
      //对象or对象数组
      return Object.keys(data).every((key) => {
        // 如果对象子元素为数组
        if (Array.isArray(data[key])) {
          if (data[key].length == 0) return false;
          return data[key].every((el) => {
            return objecAtrtIsEmpty(el);
          });
        } else if (Object.prototype.toString.call(data) === "[object Object]") {
          // 如果0表示不为空的话可以直接用!data
          // 直接用!data,非运算符的话有些值为0的话会被过滤掉
          return data[key] != "" && data[key] != null && data[key] != undefined;
        } else {
          return key != "" && key != null && key != undefined;
        }
      });
    } else if (
      Object.prototype.toString.call(data) === "[object Object]" &&
      JSON.stringify(data) === "{}"
    ) {
      return false;
    } else {
      // 处理单个值
      return data != "" && data != null && data != undefined;
    }
  };
  //
  export {
    operationForm,
    operationTable,
    cardList,
    monitoringlist,
    scoreTabel,
    operation,
    modelArr,
    objecAtrtIsEmpty,
  };
  